$(document).ready(function () {

    $('.js-reject-by-worker').on('click', function(e) {
        e.preventDefault();

        const id = $(this).data('id');
        const $declineTaskModal = $('#decline-task-modal')

        if ($declineTaskModal.length > 0) {
            $declineTaskModal.remove();
        }

        $.ajax({
            url: '/tasks/' + id + '/reject-modal',
            success: function(response) {
                $('body').append(response)
                $('#decline-task-modal').modal('show')
            }
        })
    })
});
